<template>
  <div class="modal fade" id="createUserModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Invite New User</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="signUp">
            <div class="form-group">
              <label for="email">Email Address</label>
              <input
                type="email"
                class="form-control"
                id="email"
                aria-describedby="emailHelp"
                placeholder="john.doe@example.com"
                v-model="newUserEmail"
                required
              />
            </div>
            <div class="form-group">
              <label for="firstName">First Name</label>
              <input
                type="text"
                class="form-control"
                id="firstName"
                placeholder="First name"
                v-model="newUserFirstName"
                required
              />
            </div>
            <div class="form-group">
              <label for="lastName">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                placeholder="Last name"
                v-model="newUserLastName"
                required
              />
            </div>
            <div class="form-group">
              <label for="phone">Phone Number</label>
              <input
                type="text"
                class="form-control"
                id="phone"
                placeholder="Enter Numbers Only"
                v-model="newUserPhone"
              />
            </div>
            <div class="form-group">
              <label for="organization">Organization</label>
              <select
                class="form-control"
                id="organization"
                v-model="newUserOrganization"
                required
              >
                <option value="" selected disabled>Select Organization</option>
                <option
                  v-for="org in Organizations"
                  :key="org.Organization_Id"
                  v-bind:value="org.Organization_Id"
                  >{{ org.Name }}</option
                >
              </select>
            </div>
            <div class="form-group">
              <label for="permission">Permissions</label>
              <select
                class="form-control"
                id="permission"
                v-model="newUserPermissionsGroup"
                required
              >
                <option value="null" selected disabled
                  >Select Permissions</option
                >
                <option
                  v-for="group in permissionGroups"
                  :key="group.description"
                  v-bind:value="group"
                >
                  {{ group.description }}
                </option>
              </select>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                Create User and Send Invite
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from "aws-amplify";
import { nittyGritty } from "@/constants/NittyGritty.js";
import { permissionGroups } from "@/constants/PermissionGroups";
import $ from "jquery";
import AWS from "aws-sdk";

export default {
  name: "CreateUserModal",
  data() {
    return {
      newUserEmail: "",
      errorMessage: "",
      newUserFirstName: "",
      newUserLastName: "",
      newUserPhone: "",
      newUserDate: nittyGritty.newUserDate,
      newUserPassword: nittyGritty.newUserPassword,
      newUserOrganization: "",
      newUserPermissionsGroup: null,
      permissionGroups: permissionGroups
    };
  },
  props: {
    AccountId: String,
    Organizations: Array
  },
  mounted() {
    var view = this;
    document.getElementById("phone").onkeyup = function(e) {
      view.$phoneNumberCheck(this, e);
    };
    $("#createUserModal").on("shown.bs.modal", function() {
      $("#email").focus();
    });
  },
  methods: {
    async signUp() {
      var view = this;
      view.$store.commit("updateLoading", true);
      $("#createUserModal").modal("hide");
      await view.signUpNewUser(view).then(async authUser => {
        await view.confirmNewUser(view, authUser).then(async authUser => {
          await view.createUser(view, authUser.userSub).then(async newUser => {
            await view.emailNewUser(view, newUser.User_Id, newUser.Cognito_Id);
          });
        });
      });
    },
    async createUser(view, userSub) {
      const query = `
      mutation($firstName: String!, $lastName: String!, $email: String!, $phone: String!, $lastLogin: Date!, $accountId: Int!, $organizationId: Int!, $cognitoId: String!) {
        CreateUser(firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, lastLogin: $lastLogin, accountId: $accountId, organizationId: $organizationId, cognitoId: $cognitoId) {
          User_Id
        }
      }`;
      const variables = {
        firstName: view.$data.newUserFirstName,
        lastName: view.$data.newUserLastName,
        email: view.$data.newUserEmail.toLowerCase(),
        phone: view.$data.newUserPhone,
        lastLogin: view.$data.newUserDate,
        accountId: parseInt(view.$props.AccountId),
        organizationId: parseInt(view.$data.newUserOrganization),
        cognitoId: userSub
      };
      var res = await view.$store.getters.fetcher({ query, variables });
      return res.data.CreateUser;
    },
    async signUpNewUser(view) {
      console.log("Signing Up");
      var newAuthUser = await Auth.signUp({
        username: view.$data.newUserEmail.toLowerCase(),
        password: view.$data.newUserPassword,
        attributes: {
          email: view.$data.newUserEmail.toLowerCase()
        }
      });
      return newAuthUser;
    },
    async confirmNewUser(view, newAuthUser) {
      console.log("Confirming new user: ");
      console.log(newAuthUser);
      AWS.config.credentials = new AWS.CognitoIdentityCredentials(
        view.$store.getters.awsCreds
      );
      AWS.config.region = "us-east-1";
      AWS.config.credentials.refresh(() => {
        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
        var confirmParams = {
          UserPoolId: "us-east-1_4e2RE8rbR",
          Username: view.$data.newUserEmail.toLowerCase()
        };
        console.log(cognitoidentityserviceprovider);
        cognitoidentityserviceprovider.adminConfirmSignUp(
          confirmParams,
          function(err, data) {
            if (err)
              console.log("Admin confirm sign up error: " + err, err.stack);
            // an error occurred
            else console.log("Admin confirm sign up success: " + data); // successful response
          }
        );
      });
      return newAuthUser;
    },
    emailNewUser(view, newUserId, cognitoId) {
      var lambda = new AWS.Lambda();
      var params = {
        FunctionName: "fundsgrantedsendemail-fg",
        InvocationType: "Event",
        Payload: JSON.stringify({
          emailType: "newUser",
          newUserEmail: view.$data.newUserEmail,
          newUserName: view.$data.newUserFirstName,
          newUserLink: "https://www.fundsgranted.com/#/confirmUser/" + newUserId
        })
      };
      lambda.invoke(params, function(err, data) {
        if (err) {
          console.log(err, err.stack);
          return false;
        }
        // an error occurred
        else {
          console.log("Email User Data: " + data);
          view.$store.commit("updateLoading", false);
          var newUser = {
            User_Id: newUserId,
            First_Name: view.$data.newUserFirstName,
            Last_Name: view.$data.newUserLastName,
            Email: view.$data.newUserEmail.toLowerCase(),
            Phone: view.$data.newUserPhone,
            Last_Login: view.$data.newUserDate,
            Account_Id: parseInt(view.$props.AccountId),
            Organization_Id: parseInt(view.$data.newUserOrganization),
            Cognito_Id: cognitoId
          };
          view.$emit("addedUser", newUser);
          view.clearFields();
        }
      });
    },
    clearFields() {
      this.newUserEmail = "";
      this.errorMessage = "";
      this.newUserFirstName = "";
      this.newUserLastName = "";
      this.newUserPhone = "";
      this.newUserDate = nittyGritty.newUserDate;
      this.newUserPassword = nittyGritty.newUserPassword;
      this.newUserOrganization = "";
    }
  }
};
</script>
